export const NEW_RELIC_SCRIPT = 'NEW_RELIC_SCRIPT';
export const NEW_RELIC_SCRIPT_SET = 'NEW_RELIC_SCRIPT_SET';